
import { defineComponent, ref, watchEffect, computed } from "vue";
import { Field, ErrorMessage, Form } from "vee-validate";
import { useStore } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import * as Yup from "yup";
import { useToast } from "vue-toastification";
import { Actions } from "@/store/enums/StoreEnums";
import router from "@/router";

interface IStep1 {
  id: number;
  irbApplicationId: number;
  notificationFormId: number;
  subject: string;
  userReporter: string;
  userSolver: string;
  action: string;
  eventDateCreated: Date;
  eventDateSolved: Date;
  eventName: string;
  description: string;
  resolutionDescription: string;
  other: string;
  sourceUrl: string;
  deviceInformation: string;
  type: string;
  status: string;
}

export default defineComponent({
  name: "step-3",
  components: {
    Field,
    ErrorMessage,
    Editor,
    Form,
  },
  setup() {
    const store = useStore();
    const toast = useToast();
    const listDropDownSections = [
      {
        title: "Information",
        descriptions: [{ description: " Some Information" }],
      },
    ];
    const step1 = ref<IStep1>({
      id: -1,
      irbApplicationId: -1,
      notificationFormId: -1,
      subject: "",
      userReporter: "",
      userSolver: "",
      action: "",
      eventDateCreated: new Date(),
      eventDateSolved: new Date(),
      eventName: "",
      description: "",
      resolutionDescription: "",
      other: "",
      sourceUrl: "",
      deviceInformation: "",
      type: "",
      status: "",
    });

    const validationSchema = Yup.object().shape({
      subject: Yup.string().required().label("Subject"),
      type: Yup.string().required().label("Bug Type"),
      sourceUrl: Yup.string().required().label("Source Url"),
      description: Yup.string().required().label("Description"),
      other: Yup.string().when("type", {
        is: "Others, please specify",
        then: Yup.string().required().label("Specify"),
      }),
    });

    watchEffect(() => {
      const data = store.getters.currentResearch;
      if (data === null || data.data === undefined) return;
      console.log(data);
      /*step1.value.question = data.data.question != null && data.data.question != undefined ? data.data.question : "";
      step1.value.researchDesign = data.data.researchDesign != null && data.data.researchDesign != undefined ? data.data.researchDesign : "";
      step1.value.otherResearchDesign = data.data.otherResearchDesign != null && data.data.otherResearchDesign != undefined ? data.data.otherResearchDesign : "";
      step1.value.isAnyIntervention = data.data.isAnyIntervention != null && data.data.isAnyIntervention == true ? "1" : "";
      step1.value.sumarizeIntervention = data.data.sumarizeIntervention != null && data.data.sumarizeIntervention != undefined ? data.data.sumarizeIntervention : "";
      step1.value.outcomes = data.data.outcomes != null && data.data.outcomes != undefined ? data.data.outcomes : "";
      */
    });
    const htmlForm = ref<null | HTMLFormElement>(null);
    const currentEditorToken = computed(() => {
      return store.getters.currentEditorToken;
    });

    const submit = () => {
      store
        .dispatch(Actions.POST_IRB_ISSUE, step1.value)
        .then(() => {
          toast.success("Form Submitted", {
            timeout: 2000,
          });
          store.dispatch(Actions.GET_IRB_APPLICATION_ISSUES, {});
          router.push({ name: "issues-list" });
          return;
        })
        .catch(() => {
          toast.error("Form Error", {
            timeout: 2000,
          });
        });
    };

    return {
      step1,
      listDropDownSections,
      validationSchema,
      submit,
      currentEditorToken,
    };
  },
});
